import React, { createContext, useCallback, useEffect, useState, } from "react";
export var VideoContext = createContext(null);
var useSaved = function (name, init, remember) {
    var _a = useState(init), value = _a[0], setStateValue = _a[1];
    useEffect(function () {
        if (remember.indexOf(name) === -1)
            return;
        var localValue = localStorage.getItem(name);
        if (localValue)
            setStateValue(localValue);
    }, [name, init, setStateValue, remember]);
    var setValue = function (value) {
        setStateValue(value);
        localStorage.setItem(name, value);
    };
    return {
        value: value,
        setValue: setValue
    };
};
export var VideoProvider = function (props) {
    var element = props.element, children = props.children, remember = props.remember;
    var _a = useState(true), paused = _a[0], setPaused = _a[1];
    var savedMute = useSaved("mute", "false", remember);
    var savedVolume = useSaved("volume", "1", remember);
    var mute = function (value) { return savedMute.setValue(value.toString()); };
    var muted = savedMute.value === "true";
    var setVolume = useCallback(function (value) { return savedVolume.setValue(value.toString()); }, [savedVolume]);
    var volume = Number(savedVolume.value);
    var _b = useState(0), now = _b[0], setNow = _b[1];
    var _c = useState(null), duration = _c[0], setDuration = _c[1];
    useEffect(function () {
        if (element.current === null)
            return;
        setDuration(element.current.duration);
    }, [element]);
    useEffect(function () {
        if (element.current === null)
            return;
        element.current.muted = muted;
        element.current.volume = volume;
    }, [element, muted, volume]);
    useEffect(function () {
        var current = element.current;
        if (current === null)
            return;
        current.onplay = function () { return setPaused(false); };
        current.onpause = function () { return setPaused(true); };
        current.onvolumechange = function () { return setVolume(current.volume); };
        current.ontimeupdate = function () { return setNow(current.currentTime); };
        current.ondurationchange = function () { return setDuration(current.duration); };
    }, [element, paused, setVolume]);
    useEffect(function () {
        if (element.current === null)
            return;
        element.current.muted = muted;
    }, [element, muted]);
    var play = useCallback(function () { var _a; return (_a = element.current) === null || _a === void 0 ? void 0 : _a.play(); }, [element]);
    var pause = useCallback(function () { var _a; return (_a = element.current) === null || _a === void 0 ? void 0 : _a.pause(); }, [element]);
    var seek = useCallback(function (progress) {
        if (element.current)
            element.current.currentTime = progress;
    }, [element]);
    var value = duration !== null
        ? {
            now: now,
            duration: duration,
            muted: muted,
            paused: paused,
            volume: volume,
            play: play,
            pause: pause,
            mute: mute,
            seek: seek,
            setVolume: setVolume
        }
        : null;
    return (React.createElement(VideoContext.Provider, { value: value }, children));
};
//# sourceMappingURL=index.js.map